import { Text } from "@chakra-ui/react";
import { secondaryColorThree } from "../config";

interface EyebrowProps {
  children: React.ReactNode;
  color?: string;
}

export default function Eyebrow({ children, color = secondaryColorThree }: EyebrowProps) {
  return (
    <Text
      color={color}
      fontFamily="Arial, sans-serif"
      fontSize="12px"
      fontWeight="500"
      letterSpacing="0.28em"
      textTransform="uppercase"
      mb={6}
      textDecor="strong"
    >
      {children}
    </Text>
  );
}